import { calendarConstants } from './constants';

export const saveCalendarSelection = (filterBy) => ({
  type: calendarConstants.SAVE,
  filterBy
});
